import React, {Component} from 'react';
import '../assets/teachers.css';
import {connect} from "react-redux";
import {Modal} from "react-bootstrap";
import closeModalIcon from '../assets/images/ico-close.png';
import warningIcon from '../assets/images/ico-warning.png';

const DeleteDialogBox = class DeleteDialogBoxComponent extends Component{

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: this.props.modalOpen ? this.props.modalOpen : false
        }

        this.closeModal = this.closeModal.bind(this);
        this.handleYes = this.handleYes.bind(this);
        this.handleNo = this.handleNo.bind(this);
    }

    componentDidMount() {
    }

    openModal() {
        this.setState({ isModalOpen: true });
    }

    closeModal(){
        this.props.closeClick(false);
        this.setState({ isModalOpen: false });
    }

    handleYes(event){
        this.props.confirmDelete(true);
        this.setState({isModalOpen: false});
        this.closeModal();
    }
    handleNo(event){
        this.props.confirmDelete(false);
        this.setState({isModalOpen: false});
        this.closeModal();
    }

    render() {
        return (
            <Modal id="dialogBox" show={this.props.modalOpen}>
                <div className="modal-content">
                    <div className={"row modal-body"}>
                        {/*<span style={{cursor:"pointer"}} onClick={this.closeModal}><img style={{width:50,marginTop:25,float:'right'}} src={closeModalIcon} /></span>*/}
                        <div className="section">
                            <div>
                                <img src={warningIcon} style={{width:40,height:40,position:'relative'}} />
                            </div>
                            <h1 style={{paddingTop:15}}>{this.props.sectionContent}</h1>
                            <div className={"col-md-6"}>
                                <a style={{float:'right'}} onClick={this.handleYes} className="handBtn">
                                        <span>Yes</span>
                                </a>
                            </div>
                            <div className={"col-md-6"}>
                                <a style={{float:'left'}} onClick={this.handleNo} className="handBtn">
                                        <span>No</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
};
const bindActionToProps = dispatch => {
    return {
    };
};

const mapStateToProps = state => ({});
export default connect(mapStateToProps, bindActionToProps)(DeleteDialogBox)
